<template>
  <v-row class="justify-center">
    <Form
      :items="dataInputs"
      @save="saveEdit"
      @cancel="reset"
      :maxWidth="maxWidth[0]"
      :mode="mode"
      :show="true"
      :itemsSelect="dataSelects"
      :readonly="this.stateReadonly"
      :itemsHours="dataInputsHours"
    />

    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import costCenters from "@/store/centrosDeCosto/costCenters";
import clocks from "@/store/centrosDeCosto/clocks";
import date from "@/store/common/date";
import concepts from "@/store/conceptos/concepts";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "../commons/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      stateReadonly: true,
      meses: [
        { name: "En curso", value: "E" },
        { name: "Anterior", value: "A" },
      ],
      frecuencias: [
        { name: "Mensual", value: "M" },
        { name: "Fija", value: "F" },
      ],
      oldItems: null,
      title: this.$tc("modelsLiquidations.modelsLiquidations"),
      titleDelete: this.$tc("modelsLiquidations.toModelLiquidation"),
      isLoading: true,
      maxWidth: ["900px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      showCard: true,
      itemId: null,
      showModelRelation: false,
      dataInputs: [
        {
          name: "name",
          label: "Nombre de la liquidación",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
          ],
        },
        {
          name: "diaInicio",
          label: "Día de inicio",
          data: 1,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 1 && v <= 31) ||
              this.$t("validation.maxChart.range", { min: 1, max: 31 }),
          ],
        },
      ],
      dataInputsHours: [
        {
          name: "topeMaxHExtras",
          label: "Tope de horas extras (hh:mm)",
          data: "",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
      ],

      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          width: "100px",
        },
      ],
    };
  },
  async mounted() {
    try {
      await Promise.all([
        concepts.dispatch("getConcepts"),
        concepts.dispatch("getLiquidationModels"),
        clocks.dispatch("getClocks"),
        costCenters.dispatch("getCostCenters"),
        modelsLiquidation.dispatch("getLiquidationModels"),
      ]);
      this.setEdit();
      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    modelsLiquidations() {
      return modelsLiquidation.state.modelsLiquidations;
    },
    costCenters() {
      return costCenters.state.costCenters;
    },
    clocks() {
      return clocks.state.clocks;
    },
    padding() {
      return costCenters.state.paddingNav;
    },
    salaries() {
      return concepts.state.salaries;
    },
    liquidations() {
      return concepts.state.liquidations;
    },

    dataSelects() {
      return [
        {
          name: "meses",
          label: "Meses",
          data: [],
          items: this.meses,
          itemsValue: "value",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
        },
        {
          name: "frecuencia",
          label: "Frecuencia",
          data: [],
          items: this.frecuencias,
          itemsValue: "value",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "mdi-pencil",
        },
        /*   {
          name: "tipoModeloId",
          label: "Tipo Modelo",
          data: [],
          items: this.tipoDeModelo,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "mdi-pencil",
        }, */
      ];
    },
    mode: {
      get() {
        return modelsLiquidation.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    async saveEdit(newItems) {
      const payload = this.detectChanges(newItems);

      if (Object.keys(payload).length > 0) {
        payload.liqModeloId = modelsLiquidation.state.edit.id;
        payload.oldItems = this.oldItems;

        try {
          modelsLiquidation.commit("setEditRelation", payload);
          await modelsLiquidation.dispatch("edit");
          this.showAlert(
            this.$tc("modelsLiquidations.editModelLiquidationSuccess"),
            "#82A1D0"
          );
        } catch (error) {
          if (error.response && error.response.status === 406) {
            this.showAlert(
              this.$tc("modelsLiquidations.editModelLiquidationError"),
              "#ff8d58"
            );

            this.oldItems = { ...this.oldItems };
            this.setEdit();
          } else {
            this.showAlert(
              this.$tc("modelsLiquidations.editModelLiquidationError"),
              "#ff8d58"
            );
          }
        }
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },

    detectChanges(newItems) {
      const changes = {};
      const oldItems = this.oldItems;
      if (oldItems) {
        if (oldItems.nombre !== newItems.name) {
          changes.name = newItems.name;
        }

        if (oldItems.diaInicio !== Number(newItems.diaInicio)) {
          changes.diaInicio = Number(newItems.diaInicio);
        }

        if (
          oldItems.topeMaxHExtras !==
          this.convertToMinutes(newItems.topeMaxHExtras)
        ) {
          changes.topeMaxHExtras = this.convertToMinutes(
            newItems.topeMaxHExtras
          );
        }

        if (oldItems.frecuencia !== newItems.frecuencia) {
          changes.frecuencia = newItems.frecuencia;
        }

        if (oldItems.mes !== newItems.meses) {
          changes.meses = newItems.meses;
        }
      }

      return changes;
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.stateReadonly = true;
    },
    cardView(value) {
      this.showCard = value;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");

      return `${day}-${month}-${year}`;
    },
    convertToHours(minutos) {
      if (typeof minutos !== "number" || minutos < 0) {
        return "Invalido";
      }

      const horas = Math.floor(minutos / 60);
      const minutosRestantes = minutos % 60;

      const horasFormateadas = horas.toString().padStart(2, "0");
      const minutosFormateados = minutosRestantes.toString().padStart(2, "0");

      return horasFormateadas + ":" + minutosFormateados;
    },
    convertToMinutes(value, dayValue) {
      const [hours, minutes] = value.split(":");
      const hoursInt = parseInt(hours, 10);
      const minutesInt = parseInt(minutes, 10);
      let totalMinutes = hoursInt * 60 + minutesInt;
      if (dayValue === "0") {
        totalMinutes -= 1440;
      } else if (dayValue === "2") {
        totalMinutes += 1440;
      }
      return totalMinutes;
    },
    async setEdit() {
      this.oldItems = modelsLiquidation.state.edit;
      this.dataSelects[0].data = modelsLiquidation.state.edit.mes;
      this.dataSelects[1].readonly = false;
      this.dataSelects[1].data = modelsLiquidation.state.edit.frecuencia;
      this.dataSelects[1].readonly = false;
      //this.dataSelects[2].data = modelsLiquidation.state.edit.tipoModeloId;
      this.dataInputs[0].data = modelsLiquidation.state.edit.nombre;
      this.dataInputs[1].data = modelsLiquidation.state.edit.diaInicio;
      this.dataInputsHours[0].data = this.convertToHours(
        modelsLiquidation.state.edit.topeMaxHExtras
      );

      await modelsLiquidation.dispatch(
        "getLiquidationModelId",
        modelsLiquidation.state.edit.id
      );
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          modelsLiquidation.commit(
            "setMode",
            this.$tc("modelsLiquidations.addModelLiquidation")
          );
          modelsLiquidation.commit("setOpen", true);
          break;
        case "edit":
          this.itemId = item.liqmodelId;
          modelsLiquidation.commit(
            "setMode",
            this.$tc("modelsLiquidations.editModelLiquidation")
          );
          this.openEditDialog();
          await this.setEdit(item);

          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = item.liqmodelId;
          break;

        default:
          break;
      }
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("delete")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationError"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>